
import Multiselect from '@vueform/multiselect'
import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
import { Options, Vue } from "vue-class-component";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import SiteUtils from '@/assets/ts/aplicacao/site';
import $ from "jquery"
import { Prop, Watch } from 'vue-property-decorator';
import { STATUS_QTS_SEMANAL } from "./constantes";
import QtsSemanalService from "@/service/v1/sigap/QtsSemanalService";
import QuadroHorarioService from "@/service/v1/sigap/QuadroHorarioService";

@Options({
    name: "QtsSemanalEditar",
    components: { Multiselect, BotaoSalvar },
    emits: ['qts-semanal-alterado'],
})
export default class QtsSemanalEditar extends Vue {

    @Prop() readonly modal!: any
    @Prop() readonly perfis!: any
    @Prop() readonly turma!: any
    @Prop() readonly modelo!: any

    public service = new QtsSemanalService();
    public quadroService = new QuadroHorarioService();

    public processando = false;
    public statusOpcoes = STATUS_QTS_SEMANAL;
    public quadros: any = [];

    public id: any = null;
    public descricao: any = null;
    public quadroHorarioId: any = null;
    public status: number = STATUS_QTS_SEMANAL[0].value;
    public inicio = '';
    public fim = '';
    public observacao: any = null;

    public async created() {
        await this.buscarQuadros();
    }

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    get turmaId() {
        return this.turma ? this.turma.id : this.$route.params.id;
    }

    get quadros_select() {
        return this.quadros ? this.quadros.map((i) => ({ value: i.id, label: i.descricao })) : [];
    }

    public async buscarQuadros() {
        await this.quadroService.getAll(`turmaId=${this.turmaId}&take=1000`)
            .then(response => { this.quadros = response.data; })
            .catch(() => { this.quadros = []; });
    }

    private id_de(v: any) {
        return v && typeof v === 'object' ? v.id : v;
    }

    @Watch('modelo')
    public modeloAlterado() {
        if (!this.modelo || !this.modelo.id) return;
        this.processando = true;
        this.service.getModel(this.modelo.id)
            .then(r => {
                this.id = r.id;
                this.descricao = r.descricao ?? null;
                this.quadroHorarioId = this.id_de(r.quadroHorario) ?? r.quadroHorarioId;
                this.status = this.id_de(r.status) ?? r.status ?? STATUS_QTS_SEMANAL[0].value;
                this.inicio = r.inicio ? String(r.inicio).substring(0, 10) : '';
                this.fim = r.fim ? String(r.fim).substring(0, 10) : '';
                this.observacao = r.observacao ?? null;
                this.processando = false;
            })
            .catch(() => { this.processando = false; });
    }

    public sucesso() {
        this.$emit("qts-semanal-alterado");
        $("[data-bs-dismiss='modal']").trigger({ type: "click" });
    }

    public getdados() {
        return {
            id: this.id,
            turmaId: this.turmaId,
            descricao: this.descricao,
            quadroHorarioId: this.quadroHorarioId,
            status: this.status,
            inicio: this.inicio || null,
            fim: this.fim || null,
            observacao: this.observacao || null,
        };
    }

    public salvar() {
        if (this.processando || !this.hasPermissao || !this.id) return;
        if (!this.descricao) {
            SiteUtils.toastErro('Erro!', 'Informe a descrição.');
            return;
        }
        if (this.inicio && this.fim && this.inicio > this.fim) {
            SiteUtils.toastErro('Erro!', 'A data início deve ser menor ou igual à data fim.');
            return;
        }
        this.processando = true;
        const dados = this.getdados();
        setTimeout(() => {
            this.service.update(this.id, dados)
                .then(response => {
                    SiteUtils.toastSucesso('Geração atualizada com sucesso!', response?.message);
                    this.sucesso();
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    SiteUtils.toastErro('Erro!', error?.data?.message);
                });
        }, 100);
    }
}
